import React, { useState } from "react";
import { IonIcon, IonSkeletonText } from "@ionic/react";
import { warning, card } from "ionicons/icons";
import { useGetUnpaidOrdersId, useGetOrderByIdQuery } from "../../providers/Orders";
import PaymentBottomSheet from "../../pages/parhato2/my-order-detail/PaymentBottomSheet";
import { useAuth } from "../../contexts/auth-context";
import { useHistory } from "react-router";

const UnpaidOrdersBanner = () => {
  const history = useHistory();
  const { isUserAuthenticated } = useAuth();

  const { data: unpaidOrderIds, isLoading: isUnpaidIdsLoading } = useGetUnpaidOrdersId({
    enabled: !!isUserAuthenticated,
    refetchOnMount: "always",
    refetchInterval: 60000, // 1 minute
  });

  const [showPaymentForm, setShowPaymentForm] = useState(false);

  const firstOrderId = unpaidOrderIds?.[0];


  if (!isUserAuthenticated || !firstOrderId) {
    return null;
  }

  if (isUnpaidIdsLoading) {
    return (
      <div className="mx-2.5 mb-3">
        <IonSkeletonText animated style={{ height: "74px", borderRadius: "16px", width: "100%" }} />
      </div>
    );
  }

  if (!unpaidOrderIds || unpaidOrderIds.length === 0) {
    return null;
  }

  const unpaidCount = unpaidOrderIds.length;


  const handleClose = () => {
    setShowPaymentForm(false);
  };

  const handleOpenOrderDetail = () => {
    history.push(`/my-order-detail/${firstOrderId}`);
  };

  return (
    <div className="flex items-center justify-between p-3 bg-[#FFFBE6] border border-[#FFE58F] rounded-2xl mx-2.5 mb-3 relative overflow-visible shadow-sm">
      <div className="flex items-center gap-3">
        <IonIcon icon={warning} className="text-primary text-[32px]" />
        <div className="flex flex-col">
          <span className="font-bold text-[#1F1F1F] text-sm">
            Пора оплатить{" "}
            <span
              onClick={handleOpenOrderDetail}
              className="hover:opacity-80 underline underline-offset-2 font-bold cursor-pointer"
            >
              заказ №{firstOrderId}
            </span>
          </span>
          <span className="text-[#8C8C8C] text-xs">Доставим после оплаты</span>
        </div>
      </div>

      <div className="relative">
        <button
          onClick={() => setShowPaymentForm(true)}
          className="bg-primary hover:bg-primary-shade active:bg-primary-tint transition-colors px-4 py-2 rounded-[20px] flex items-center gap-2 font-bold text-sm text-[#1F1F1F]"
        >
          <span>Оплатить</span>
          <IonIcon icon={card} className="text-lg" />
        </button>
        {unpaidCount > 0 && (
          <div className="absolute -top-1.5 -right-1.5 bg-[#FF4D4F] text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full border-2 border-white z-10">
            {unpaidCount}
          </div>
        )}
      </div>

      <PaymentBottomSheet
        orderId={String(firstOrderId ?? "")}
        onClose={handleClose}
        onSuccess={handleClose}
        showPaymentForm={showPaymentForm}
      />
    </div>
  );
};

export default UnpaidOrdersBanner;
